import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxCardObject from "src/components/card/SfxCardObject.vue"
import { showNotImplementedNotification } from "src/util/functions/notifications"
import { showIdentify } from "src/util/functions/overlays"
import {
  Identifier,
  IdentifierEntityTarget,
  IdentifierAssociationType,
  IdentifierRemove,
  IdentifierScanAction,
} from "src/util/types/dataModels/identifier"
import { computed, PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogListIdentifier',
  props: {
  entityName: {
    type: String,
    required: true,
  },

  entityId: {
    type: String,
    required: true,
  },

  associationType: {
    type: String as PropType<IdentifierAssociationType>,
    required: true,
  },

  list: {
    type: Array as PropType<Identifier[]>,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()
const elementsSelected = ref<Identifier[]>([])

const leftButtonText = computed(() =>
  elementsSelected.value.length === 0
    ? t("sfxButtons.btn_add_identifier")
    : t("sfxButtons.btn_cancel")
)
const leftButtonFunction = computed(() =>
  elementsSelected.value.length === 0 ? clickAddIdentifier : dialogClose
)

const rightButtonText = computed(() =>
  elementsSelected.value.length === 0
    ? t("sfxButtons.btn_got_it")
    : t("sfxButtons.btn_disassociate")
)
const rightButtonFunction = computed(() =>
  elementsSelected.value.length === 0 ? dialogClose : clickDisassociate
)

//endregion

//region Functions

function dialogClose() {
  onDialogCancel()
}

function clickAddIdentifier() {
  if (process.env.IS_MANAGER_MODE) {
    // TODO: Handle Add identifier for manager mode
    showNotImplementedNotification()
    return
  }

  // TODO: Handle PROPOSE new identifier case (adding another one to the list) when we have change requests

  const newProposition = props.list && props.list.length > 0

  const scanAction: IdentifierScanAction = newProposition ? "PROPOSE" : "ASSOCIATE"
  const identifierEntity: IdentifierEntityTarget = {
    entityType: props.associationType,
    entityName: props.entityName,
    entityId: props.entityId,
  }

  showIdentify(scanAction, identifierEntity).onOk(onDialogOK)
}

function clickDisassociate() {
  const action: IdentifierRemove = "DISASSOCIATE"
  const data = elementsSelected.value
  onDialogOK({ action, data })
}

function itemClick(itemClicked: Identifier) {
  const indexOfItem = elementsSelected.value.findIndex((item) => item.id === itemClicked.id)

  if (indexOfItem === -1) {
    elementsSelected.value.push(itemClicked)
  } else {
    const lastIndex = elementsSelected.value.length - 1
    elementsSelected.value[indexOfItem] = elementsSelected.value[lastIndex]
    elementsSelected.value.pop()
  }
}

function determineClass(item: Identifier) {
  return elementsSelected.value.includes(item) ? "sfx-card--selected" : undefined
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin sfx-dialog-list" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("sfxDialogListIdentifier.title")), 1)
            ]),
            _: 1
          }),
          (props.list?.length === 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_q_card_section, { class: "text-body1" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: _unref(t)('sfxDialogListIdentifier.identifier_none')
                    }, null, 8, _hoisted_1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(SfxBtnOutline, {
                      onClick: dialogClose,
                      label: _ctx.$t('sfxButtons.btn_got_it'),
                      class: "col"
                    }, null, 8, ["label"]),
                    _createVNode(SfxBtn, {
                      onClick: clickAddIdentifier,
                      label: _ctx.$t('sfxButtons.btn_add_identifier'),
                      class: "col"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_q_card_section, { class: "text-body1" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: _unref(t)('sfxDialogListIdentifier.identifier_all')
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, { class: "text-caption text-fun-label-and-icon q-pb-none" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: _unref(t)('sfxDialogListIdentifier.hint')
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, { class: "sfx-dialog-list-elements" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, index) => {
                      return (_openBlock(), _createBlock(SfxCardObject, {
                        key: index,
                        "object-type": item.type,
                        title: item.data,
                        user: "",
                        "date-time": item.updated_dt,
                        onClick: ($event: any) => (itemClick(item)),
                        class: _normalizeClass(determineClass(item))
                      }, null, 8, ["object-type", "title", "date-time", "onClick", "class"]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(SfxBtnOutline, {
                      onClick: leftButtonFunction.value,
                      label: leftButtonText.value,
                      class: "col"
                    }, null, 8, ["onClick", "label"]),
                    _createVNode(SfxBtn, {
                      onClick: rightButtonFunction.value,
                      label: rightButtonText.value,
                      class: "col"
                    }, null, 8, ["onClick", "label"])
                  ]),
                  _: 1
                })
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})